import React, {useEffect, useRef, useState} from 'react';
import {Text, Icons, Stills, Sections} from "../video_comic_data";

import s from "../styles.module.css"
import {BackgroundVideo} from "../../../components/backgroundVideo";
import {PATH_TO_HQ_VIDEOS} from "../components/videoManager";
import FadeIn from "../../../components/FadeIn";
import style from "../../../components/backgroundVideo.module.css";
import {Utils} from "../../../components/audioUtils";


export default function Enter({galleryLoaded, galleryLoadProgress, onLoaded, onEnterButtonPressed}) {
    const [videoMuted, setVideoMuted] = useState(true);
    
    return (
        <>
            <BackgroundVideo 
                src={PATH_TO_HQ_VIDEOS + "/video_enter.mp4"} 
                loadFullyBeforePlaying={true}
                loadingImage={Stills.EnterBGVideo} 
                onReadyToPlay={onLoaded}
                muted={videoMuted}
            />
            
            <FadeIn duration={500}>               
                <EnterButton loadProgress={galleryLoadProgress} loaded={galleryLoaded} onPressed={onEnterButtonPressed}/>
                <AboutWindow/>
                <MuteUnMuteWindow onChangeState={(value) => setVideoMuted(value)}/>
            </FadeIn>
        </>
    )
}

function MuteUnMuteWindow({onChangeState}) {
    const [muted, setMuted] = useState(true);
    
    function ChangeMuteState(value) {
        setMuted(value);
        onChangeState?.(value);
    }
    
    return (
        <div id={"mute unmute window"}>
            <MuteUnMuteButton muteState={muted} onClick={() => ChangeMuteState(!muted)}/>
        </div>
    )
}

function MuteUnMuteButton({muteState, onClick})
{
    function HandleKeyUp(event) {
        // console.log("HandleKeyUp!", event)
        const key = event.key;
        switch (key) {
            case "Enter":
            case " ":
                onClick?.();
                break;
        }
    }
    
    return (
        <div id={"mute unmute button"}
             className={s.muteUnmuteButton} 
             title={"Toggle sound"}

             tabIndex={0}
             onClick={onClick}
             onKeyUp={HandleKeyUp}
             
        >
            {muteState ? "🔈" : "🔊"}
        </div>
    )
}

function AboutWindow() {
    const [open, setOpen] = useState(false)

    return (
        <div id={"about text window"}>
            <div id={"about text container"} className={s.aboutTextContainer} title={open ? "Close" : "About"}>
                <OpenCloseButton openState={open} onClick={() => setOpen(!open)}/>

                {open
                    ? <AboutText/>
                    : null}

            </div>
        </div>

    )
}

function AboutText() {
    return (
        <div id={"about text"}>
            <div className={s.aboutTextFirstLine}> {Text.AboutFirstLine} </div>
            {Text.About.map((content, index) => (<div className={s.aboutText}> {content} </div>))}
        </div>
    )
}

function OpenCloseButton({openState, onClick}) {

    function HandleKeyUp(event) {
        // console.log("HandleKeyUp!", event)
        const key = event.key;
        switch (key) {
            case "Enter":
            case " ":
                onClick?.();
                break;
        }
    }
    return (
        <div
            id={"open close button "} 
            className={s.openCloseButton}

            tabIndex={0}
            onClick={onClick}
            onKeyUp={HandleKeyUp}
            
        >            
            {openState ? "X" : "?"}
        </div>
    )
}


function EnterButton({loadProgress = 0, loaded, onPressed}) {
    const size = 15;
    
    function handlePress(event) {
        if (loadProgress >= 1) {
            if (event.type === "click") {
                onPressed?.();
            } else if (event.type === "keyup") {
                if (event.key === "Enter" || event.key === " ") {
                    onPressed?.();
                }
            } 
        }
    }

    return (
        <div id={"enter button"}>
            
            <div className={s.enter_button} 
                 tabIndex={0}
                 onKeyUp={handlePress}
            >
                
                <div id={"icon"}>                                     
                    {loaded
                        ? <EnterImage alt={"Click to enter"} size={size} onPressed={handlePress}/>
                        : <LoadingIcon alt={"Please wait while the piece is loading."} size={size}/>
                    }
                </div>
              
                <LoadingBar loadProgress={loadProgress}/>
            </div>         
        </div>
    )
}

function LoadingBar({loadProgress})
{
    return (
        <div id={"load bar container"} className={s.loadingBarContainer}
             // style={{opacity: loadProgress === 1 ? 0 : 1}}
        >
            <div id={"load bar"} className={s.loadingBar} style={{width: `${Utils.mapToRange(loadProgress, 0, 1, 0, 100)}%`}}>

            </div>
 
            <div id={"load bar text"} className={s.loadingBarText} >
                {`${(loadProgress * 100).toFixed(0)}%`}
            </div>
        </div>
    )
}

function EnterImage({alt, size, onPressed}) {
    const [src, setSrc] = useState("")

    function HandleHover(isHovering) {
        setSrc(isHovering ? Icons.EnterButtonHover : Icons.EnterButton)
    }

    return (
            <img
                className={s.enter_image}
                title={alt}
                alt={alt}
                onClick={onPressed}
                src={src !== "" ? src : Icons.EnterButton}
                onMouseOver={() => HandleHover(true)}
                onMouseOut={() => HandleHover(false)}
                style={{
                    width: `${size}vw`,
                }}
                
                // tabIndex={0}                
                // onKeyDown={handleKeyDown}
                // onClick={onPressed}
            />
    )
}

function LoadingIcon({alt, size}) {
    return (
            <img
                className={s.enter_image}
                title={alt}
                alt={alt}
                src={Icons.EnterButtonLoading}
                style={{
                    width: `${size}vw`,
                    cursor: `wait`
                }}
            />
    )
}


